import React from 'react';
import { LandingPageHeader } from '@care/navigation';
import { useRouter } from 'next/router';
import { AppFooter } from '@care/enterprise-components';
import getConfig from 'next/config';
import { useFlag } from '@/context/FeatureFlagsContext';
import Layout from '@/components/shared/Layout';
import CareLogo from '@/components/shared/CareLogo';
import { ENTERPRISE_ROUTES, FEATURE_FLAGS, memberEnrollment } from '@/constants';
import PageContent from './components/PageContent';
import FooterWhiteBackgroundWrapper from '@/components/shared/FooterWhiteBackgroundWrapper';

const { WELCOME } = ENTERPRISE_ROUTES;

const OneClickEnrollmentPage: React.FC = () => {
  const router = useRouter();
  const groupName = router.query.groupName as string;
  const employeeUUID = router.query.id as string;
  const {
    publicRuntimeConfig: { CZEN_GENERAL },
  } = getConfig();

  if (!groupName || !employeeUUID) {
    router.push(`${memberEnrollment}${WELCOME}`);
    return <></>;
  }

  // evaluate one click enrollment LD flag, if false redirect to welcome page
  const oneClickEnrollEval = useFlag(FEATURE_FLAGS.ENT_ONE_CLICK_ENROLLMENT_FLAG.key);
  const oneClickEnrollV2Eval = useFlag(FEATURE_FLAGS.ENT_ONE_CLICK_ENROLLMENT_V2_FLAG.key);

  // TODO: Resolve during code review or earlier
  // For code review: having v2 on and v1 off is a misconfig, we can add the check here
  // too if we want to be extra cautious. Else we can leave it like this.
  if (!oneClickEnrollEval) {
    router.push(`${memberEnrollment}${WELCOME}`);
    return <></>;
  }

  return (
    <>
      <LandingPageHeader logo={<CareLogo />} />
      <Layout>
        <PageContent
          groupName={groupName}
          employeeUUID={employeeUUID}
          isOneClickV2={oneClickEnrollV2Eval}
        />
      </Layout>
      <FooterWhiteBackgroundWrapper>
        <AppFooter baseUrl={CZEN_GENERAL} />
      </FooterWhiteBackgroundWrapper>
    </>
  );
};

export default OneClickEnrollmentPage;
